import { OverigeFinancieelPost } from "../../../../.generated/rapportage/rapportagetypes";
import { Column } from "../../components/BaseTable";
import { getFormattedDateFromString } from "../../../../shared/utils/dates";
import { bedragFormat } from "../../../../shared/utils/currency";

export const getOverigeFinancielePostenColumns = (
  isHuidig?: boolean
): Column<OverigeFinancieelPost>[] => [
  {
    header: "Correctiepost",
    accessor: () => " ",
    align: "left",
  },
  {
    header: "Lopend of nieuwe polis",
    accessor: isHuidig ? () => "Bestaande polis" : "lopendeOfNieuwePolis",
    align: "left",
  },
  {
    header: "Omschrijving",
    accessor: "omschrijving",
    align: "left",
  },
  {
    header: "Correctie moet behandeld worden als",
    accessor: "behandelenAls",
    align: "left",
  },
  {
    header: "Correctie moet fiscaal behandeld worden als",
    accessor: "fiscaalBehandelenAls",
    align: "left",
  },
  {
    header: "Ingangsdatum",
    accessor: (data: OverigeFinancieelPost) => {
      return getFormattedDateFromString(data.ingangsdatum);
    },
    align: "left",
  },
  {
    header: "Einddatum verzekering, looptijd",
    accessor: (data: OverigeFinancieelPost) => {
      return `${getFormattedDateFromString(data.einddatum)}, ${data.looptijd}`;
    },
    align: "left",
  },
  {
    header: "Correctie heeft betrekking op",
    accessor: "betrekkingOp",
    align: "left",
  },
  {
    header: "Bedrag, termijn",
    accessor: (data: OverigeFinancieelPost) => {
      return `${bedragFormat(data.bedrag)}, ${data.termijn}`;
    },
    align: "left",
  },
];
